import { UnitsInterface } from "scenes/UnitsManager/interfaces";
import { PointClassificationsNames, LayerAlias } from "constant";

export const groupTotalsPointsByClassifications = (
  layers: Record<LayerAlias, UnitsInterface>
  // layerNames?: LayerAlias[]
) => {
  const rawTotals: Record<string, number> = {};
  // const selectedLayers =
  //   layerNames && layerNames.length > 0 ? layerNames : Object.keys(layers);
  const selectedLayers = Object.keys(layers);

  for (const layerName of selectedLayers) {
    const layer = layers[layerName];
    if (!layer) continue;

    for (const unit of layer.Point.units) {
      const alias = unit.additional?.classification?.alias ?? "unclassified";
      rawTotals[alias] = (rawTotals[alias] ?? 0) + 1;
    }
  }

  rawTotals.all = Object.values(rawTotals).reduce((sum, val) => sum + val, 0);

  const sortedAliases = Object.keys(rawTotals)
    .filter((alias) => rawTotals[alias] > 0)
    .sort((a, b) => {
      if (a === "all") return -1;
      if (b === "all") return 1;
      if (a === "unclassified") return 1;
      if (b === "unclassified") return -1;
      return 0;
    });

  const result: Record<string, { label: string; total: number }> = {};

  for (const alias of sortedAliases) {
    result[alias] = {
      label: alias === "all" ? "All points" : PointClassificationsNames[alias],
      total: rawTotals[alias]
    };
  }

  return result;
};
